import { render, staticRenderFns } from "./data55.vue?vue&type=template&id=fadae026&scoped=true"
import script from "./data55.vue?vue&type=script&lang=js"
export * from "./data55.vue?vue&type=script&lang=js"
import style1 from "./data55.vue?vue&type=style&index=1&id=fadae026&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadae026",
  null
  
)

export default component.exports